document.addEventListener("DOMContentLoaded", function (event) {
  // let cooling = document.querySelector('.cooling_free')
  // if(cooling) {
  //   cooling.addEventListener('click', function(){
  //       this.classList.toggle('active')
  //   })
  // }

  setInterval(function () {
    const priceSpan = document.querySelector(
      ".product-info__variant-picker variant-picker.variant-picker button.select p span"
    );
    if (priceSpan) {
      let priceText = priceSpan.textContent.trim();
      let numericPrice = parseFloat(priceText.replace(/[^0-9.]/g, ""));
      if (!isNaN(numericPrice)) {
        let afterPayPrice = (numericPrice / 4).toFixed(2);
        let currencySymbol = priceText.replace(/[0-9.,]/g, "").trim();
        let finalText = `${currencySymbol}${afterPayPrice}`;
        const afterPaySpan = document.querySelector(
          ".adtrer_pay_text p span.after_pay_price"
        );
        if (afterPaySpan) {
          afterPaySpan.textContent = finalText;
        }
      }
    }
  }, 1000);

  let proComparePOp = document.querySelector(".purchase-Pro_title button");
  if (proComparePOp) {
    proComparePOp.addEventListener("click", function () {
      document.querySelector(".pro_compare").style.display = "flex";
    });
    let proCompareCart = document.querySelectorAll(".compare_Upsell_add");
    if (proCompareCart) {
      proCompareCart.forEach(function (button) {
        button.addEventListener("click", function () {
          var id = this.getAttribute("data-id");
          console.log(id);
          var qty = 1;
          console.log(qty);

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: id,
              quantity: qty,
            }),
          })
            .then(function (response) {
              if (response.ok) {
                console.log("success");
                fetch("/?sections=cart-drawer")
                  .then((response) => response.json())
                  .then((data) => {
                    const parser = new DOMParser();
                    const htmlDoc = parser.parseFromString(
                      data["cart-drawer"],
                      "text/html"
                    );

                    const newInner = htmlDoc.querySelector(
                      ".cart-drawer__inner"
                    );
                    const currentInner = document.querySelector(
                      "cart-drawer .cart-drawer__inner"
                    );

                    if (newInner && currentInner) {
                      currentInner.innerHTML = newInner.innerHTML;
                    }
                  })
                  .catch((error) => {
                    console.error(
                      "Error refreshing cart drawer content:",
                      error
                    );
                  });
              } else {
                console.log("error");
              }
            })
            .catch(function (error) {
              console.log("error", error);
            });
        });
      });
    }
  }
  let proCompareClose = document.querySelector(".compare_close button");
  if (proCompareClose) {
    proCompareClose.addEventListener("click", function () {
      document.querySelector(".pro_compare").style.display = "none";
    });
  }
});

document.addEventListener("DOMContentLoaded", function (event) {
  // let cooling = document.querySelector('.cooling_free');
  //   cooling.addEventListener('click', function(){
  //       this.classList.toggle('active')
  //   })

  // const options = document.querySelectorAll(".popover-listbox__option");
  // options.forEach(function(option) {
  //     option.addEventListener("click", function() {
  //         const span = option.querySelector("span");
  //         const spanText = span ? span.textContent.trim() : "";
  //         let mainText = option.textContent.trim();
  //         if (spanText) {
  //             mainText = mainText.replace(spanText, "").trim();
  //         }
  //         const targetButton = document.querySelector(".variant-picker__option button.select");
  //         if (targetButton) {
  //             targetButton.textContent = "";
  //             const mainTextNode = document.createTextNode(mainText);
  //             const newSpan = document.createElement("span");
  //             newSpan.textContent = spanText;
  //             targetButton.appendChild(mainTextNode);
  //             targetButton.appendChild(newSpan);
  //         }
  //     });
  // });

  const today = new Date();
  const secondDate = new Date(today);
  secondDate.setDate(today.getDate() + 2);
  const fourthDate = new Date(secondDate);
  fourthDate.setDate(secondDate.getDate() + 1);
  function getDaySuffix(day) {
    if (day >= 11 && day <= 13) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }
  function formatDate(date) {
    const day = date.getDate();
    const suffix = getDaySuffix(day);
    const month = date.toLocaleString("en-US", { month: "short" });
    return `${day}${suffix} ${month}`;
  }
  const output = `${formatDate(fourthDate)}`;
  document.querySelector(
    ".ship_delivery_row p"
  ).innerHTML = `<span>Ships today</span>  Delivery by ${output}`;
});
